import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangelogComponent } from './changelog/changelog.component';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { ResetPasswordComponent } from './options/reset-password/reset-password.component';
import { SharedPrintComponent } from './shared-print/shared-print.component';

const routes: Routes = [
  { path: 'bookID/:bookID', component: HomeComponent },
  { path: 'bookID/:bookID/:pin', component: HomeComponent, pathMatch: 'full' },
  { path: 'print/:bookID', component: SharedPrintComponent },
  { path: 'changelog', component: ChangelogComponent },
  { path: 'reset-password/:resetpasswordtoken', component: ResetPasswordComponent },
  { path: '', component: ErrorComponent }
];

/**ToDo Documentazione */
@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule { }
